import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, takeEvery, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestFrentistas({ payload }) {
  try {
    let params = {
      ...payload.params,
      wherefield: [],
      valuewherefield: [],
      typewherefield: []
    }

    if (payload.params.wherefield) {
      params.wherefield = [...payload.params.wherefield]
      params.valuewherefield = [...payload.params.valuewherefield]
      params.typewherefield = [...payload.params.typewherefield]
    }

    const frentistaState = yield select((state) => state.frentista)
    if (params.poco_codigo) {

      params.wherefield.push('poco_codigo')
      params.valuewherefield.push(params.poco_codigo)
      params.typewherefield.push('EQUALS')
    } else if (frentistaState.params.poco_codigo) {
      params.wherefield.push('poco_codigo')
      params.valuewherefield.push(frentistaState.params.poco_codigo)
      params.typewherefield.push('EQUALS')
    }
    const response = yield call(api.get, 'frentista', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteFrentista({ payload }) {
  try {
    const { idfrentista, params } = payload;

    yield call(api.delete, `frentista/${idfrentista}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { frentista, params } = payload;

    yield call(api.post, 'frentista', frentista);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    // history.push('/cadfrentista');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idfrentista } = payload;

    const { data } = yield call(api.get, `frentista/${idfrentista}`);

    // data.param5usuariooperador = JSON.stringify(data.param5usuariooperador);
    // data.param7usuariooperador = JSON.stringify(data.param7usuariooperador);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { frentista, params } = payload;

    yield call(api.put, 'frentista', frentista);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    // history.push('/cadfrentista');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {

    let params = {
      ...payload.params,
      wherefield: [],
      valuewherefield: [],
      typewherefield: []
    }

    if (payload.params.wherefield) {
      params.wherefield = [...payload.params.wherefield]
      params.valuewherefield = [...payload.params.valuewherefield]
      params.typewherefield = [...payload.params.typewherefield]
    }

    const frentistaState = yield select((state) => state.frentista)
    if (params.poco_codigo) {

      params.wherefield.push('poco_codigo')
      params.valuewherefield.push(params.poco_codigo)
      params.typewherefield.push('EQUALS')
    } else if (frentistaState.params.poco_codigo) {
      params.wherefield.push('poco_codigo')
      params.valuewherefield.push(frentistaState.params.poco_codigo)
      params.typewherefield.push('EQUALS')
    }

    const response = yield call(api.get, 'frentista', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });


    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    console.log(erros)
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@frentista/FRENTISTAS_IN_REQUEST', requestFrentistas),
  takeLatest('@frentista/DELETE_FRENTISTA', deleteFrentista),
  takeLatest('@frentista/SUCCESS_REMOVE', requestFrentistas),
  takeLatest('@frentista/STORE_FRENTISTA', store),
  takeLatest('@frentista/FIND_FRENTISTA', find),
  takeLatest('@frentista/UPDATE_FRENTISTA', update),
  takeLatest('@frentista/RECORD_FILTERING', applyedFilters),
]);
